var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35px",
    height: "35px",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1405 2162 c-75 -25 -101 -111 -51 -169 l24 -28 211 -3 c116 -2 211 -5 211 -8 0 -3 -183 -191 -408 -417 -224 -227 -558 -565 -742 -752 -184 -187 -338 -341 -342 -343 -4 -2 -8 90 -10 203 l-3 207 -33 29 c-44 39 -90 39 -134 0 l-33 -29 -3 -355 -3 -354 36 -32 36 -31 327 0 c183 0 343 4 362 10 80 22 95 151 22 187 -9 4 -109 10 -221 13 l-203 5 423 430 c510 519 1071 1085 1075 1085 2 0 4 -93 6 -206 l3 -206 33 -29 c44 -39 90 -39 134 0 l33 29 3 355 3 354 -36 32 -36 31 -332 -1 c-183 -1 -341 -4 -352 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.d8f93905d13e7fd1724ff7916a8d257f.svg";
export { ForwardRef as ReactComponent };